import { useState, useEffect } from 'react';

interface Slide {
  image: string;
  title: string;
  subtitle: string;
}

/**
 * Slides data.
 * Using a typed constant makes TypeScript aware of the exact shape
 * and prevents accidental syntax errors.
 */
const slides: Slide[] = [
  {
    image: 'https://static.readdy.ai/image/d1ac1a7e8ecb2076670ea669c1984b4f/9d5bed1df8526320b7d664a7dce606df.jpeg',
    title: 'Transformamos Talentos em Resultados',
    subtitle: 'Soluções completas em Recursos Humanos para sua empresa',
  },
  {
    image: 'https://static.readdy.ai/image/d1ac1a7e8ecb2076670ea669c1984b4f/a787683b850a080ab64543ed0097c6b8.jpeg',
    title: 'Recrutamento Estratégico',
    subtitle: 'Encontramos os profissionais ideais para o seu negócio',
  },
];

export default function Hero() {
  const [currentSlide, setCurrentSlide] = useState<number>(0);

  /** Auto‑advance the carousel every 5 seconds */
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5_000);
    return () => clearInterval(timer);
  }, []);

  /** Jump to a specific slide (used by the navigation dots) */
  const goToSlide = (index: number) => {
    if (index < 0 || index >= slides.length) {
      console.warn(`goToSlide: index ${index} out of bounds`);
      return;
    }
    setCurrentSlide(index);
  };

  /** Smooth scroll helper – moves to the element with the given id */
  const scrollToSection = (id: string, offset = 80) => {
    const element = document.getElementById(id);
    if (!element) {
      console.warn(`scrollToSection: element with id "${id}" not found`);
      return;
    }
    const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
    const targetPosition = elementTop - offset;
    window.scrollTo({ top: targetPosition, behavior: 'smooth' });
  };

  return (
    <section id="inicial" className="relative h-screen overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
          aria-hidden={index !== currentSlide}
        >
          {/* Background image */}
          <div className="absolute inset-0 w-full h-full">
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover object-top"
            />
          </div>

          {/* Dark gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50" />

          {/* Slide content */}
          <div className="relative h-full flex items-center justify-center">
            <div className="text-center text-white px-6 max-w-4xl mx-auto w-full">
              <div className="flex justify-center mb-8">
                <img
                  src="https://static.readdy.ai/image/d1ac1a7e8ecb2076670ea669c1984b4f/93a34456c721fef1adb2b492f0a1d4c5.png"
                  alt="Persona Pro Logo"
                  className="w-60 h-60 object-contain drop-shadow-2xl"
                />
              </div>
              <h1 className="text-3xl md:text-4xl font-bold mb-4">{slide.title}</h1>
              <p className="text-base md:text-lg mb-8 text-gray-100">{slide.subtitle}</p>
              <button
                onClick={() => scrollToSection('contato', 80)}
                className="bg-[#D4AF37] text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-[#B8941F] transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                Fale Conosco
              </button>
            </div>
          </div>
        </div>
      ))}

      {/* Navigation dots */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-3 z-10">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
              index === currentSlide
                ? 'bg-[#D4AF37] w-8'
                : 'bg-white/50 hover:bg-white/80'
            }`}
            aria-label={`Ir para slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
}
